function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 19H10C7.87827 19 5.84344 18.1571 4.34315 16.6569C2.84285 15.1566 2 13.1217 2 11V6H6V11C6 12.0609 6.42143 13.0783 7.17157 13.8284C7.92172 14.5786 8.93913 15 10 15V6H14V10.5L14.03 10.496C15.126 10.3592 16.1343 9.82686 16.8654 8.99892C17.5965 8.17098 18 7.10452 18 6H22L21.658 7.711C21.4532 8.73509 21.0171 9.69886 20.3832 10.5288C19.7493 11.3588 18.9341 12.033 18 12.5C18.9083 12.8026 19.7186 13.3439 20.346 14.0671C20.9734 14.7904 21.3947 15.669 21.566 16.611L22 19H18C18 17.8955 17.5965 16.829 16.8654 16.0011C16.1343 15.1731 15.126 14.6408 14.03 14.504V19.004L14 19Z",
  stroke: "#837FB8",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgVk = function SvgVk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vk.e6377685.svg";
export { ForwardRef as ReactComponent };